import { extractExternalVideoEmbedUrl } from '../../propertyCard/propertyCardUtils';

const CONVERTIBLE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtu.be',
  'vimeo.com',
  'www.vimeo.com',
]);
const VIMEO_PLAYER_HOST = 'player.vimeo.com';
const VIMEO_PLAYER_PATH = /^\/video\/\d+/;

/**
 * The trimmed URL when `text` is, in its entirety, a link to an external video
 * platform the carousel can embed (YouTube or Vimeo), otherwise null. Used to
 * turn a pasted link into a video slide; anything else pasted stays ignored.
 *
 * Whole-string match on purpose: a sentence that merely mentions a video link
 * must not be swallowed. Links `extractExternalVideoEmbedUrl` can't convert
 * (e.g. YouTube /shorts/, a Vimeo profile page) are rejected too, since they'd
 * render as a blocked iframe.
 */
export function externalVideoUrl(text: string | null | undefined): string | null {
  const candidate = text?.trim();
  if (!candidate || /\s/.test(candidate)) return null;
  let parsed: URL;
  try {
    parsed = new URL(candidate);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
  const host = parsed.hostname.toLowerCase();
  if (host === VIMEO_PLAYER_HOST) return VIMEO_PLAYER_PATH.test(parsed.pathname) ? candidate : null;
  if (!CONVERTIBLE_HOSTS.has(host)) return null;
  return extractExternalVideoEmbedUrl(candidate) !== candidate ? candidate : null;
}
